import { gql } from "@apollo/client";

export const GET_RESPONSE = gql`
  query getBooks($book_id: ID!) {
    book: CommunityBook(id: $book_id, published_only: true) {
      author {
        id
        name
        image
        __typename
      }
      categories {
        id
        name
        buy_text
        __typename
      }
      chapters
      description_short
      themes
      disabled
      features
      glossary
      glossary_less
      guide_url
      has_aboutstory
      has_cultural
      has_glossary
      has_introduction
      has_prereading
      id
      image_ver
      images {
        cover
        thumb
        poster
        __typename
      }
      is_new
      keys_url
      language {
        id
        name
        active
        __typename
      }
      level {
        id
        name
        __typename
      }
      level_id
      nav_colors {
        background
        color
        __typename
      }
      print_url
      rank
      rating
      rating_students
      rating_teachers
      read_time
      release_date
      score
      title
      total_ratings
      total_words
      tense
      url
      user_chapter
      unique_words
      video_url
      vocab_url
      __typename
      id
    }
    students {
      id
      name
      class {
        name
        id
      }
      history {
        score
        allow_retake
        request_retake
      }
    }
  }
`;

export const GETREVIEWS = gql`
  query getBookReviews($id: ID!, $class_id: ID) {
    bookReviews(id: $id, class_id: $class_id) {
      book_id
      user_id
      is_teacher
      rating
      opinion
      timestamp
    }
  }
`;
